import type { CmsPage } from "@/cms/models";

/** Existing menu membership/order stays authoritative; placement is opt-in. */
export function getPageNavigation(pages: CmsPage[]) {
  const visible = pages.filter(
    (page) =>
      page.type !== "footer" && page.type !== "article" && page.includeInMenu,
  );
  return {
    primary: visible.filter(
      (page) =>
        page.menuPlacement === "primary" || page.menuPlacement === "both",
    ),
    sidebar: visible.filter((page) => page.menuPlacement !== "primary"),
  };
}

export function getPageMenuHref(page: CmsPage) {
  return page.redirectToExternal && page.externalUrl
    ? page.externalUrl
    : page.slug || "/";
}
